import _ from 'lodash'
import {createAction, createReducer} from 'redux-act'
import axios from 'axios'
import qs from 'qs'

import {addSubmitForm, deleteSubmitForm} from './app'
import {baseUrl} from './../scripts/env'
import {submit as login} from 'ducks/login'

export const REDUCER = 'password_recovery'
const NS = `@@${REDUCER}/`

export const initRequest = createAction(`${NS}INIT_REQUEST`)
export const initSuccess = createAction(`${NS}INIT_SUCCESS`)
export const initFailure = createAction(`${NS}INIT_FAILURE`)

export const commitRequest = createAction(`${NS}COMMIT_REQUEST`)
export const commitSuccess = createAction(`${NS}COMMIT_SUCCESS`)
export const commitFailure = createAction(`${NS}COMMIT_FAILURE`)

export const reset = createAction(`${NS}RESET`)
export const change = createAction(`${NS}CHANGE`)

const initialState = {
    codeSent: false,
    data: {
      login: { value: null },
      restore_code: { value: null },
      password: { value: null },            
      passwordConfirmation: { value: null },   
    }
}

export const sendInit = async (login, locale, dispatch) => {
  var response = await axios({
      method: 'POST',
      url: baseUrl + '/auth/password/reset',
      data: qs.stringify({ login, locale })
  })
  if (_.get(response, 'data.ok', false) === false) {
      dispatch(initFailure())
      return false
  }
  dispatch(initSuccess())
  return true
}

export const sendCommit = async (email, restore_code, password, dispatch) => {
  var response = await axios({
      method: 'POST',
      url: baseUrl + '/auth/password/restore',
      data: qs.stringify({ email, restore_code, password })
  })
  if (_.get(response, 'data.ok', false) === false) {
      dispatch(commitFailure())
      return false
  }
  dispatch(commitSuccess())
  return true
}

export const init = ({ login, locale }) => async (dispatch) => {
  dispatch(addSubmitForm(REDUCER))
  let commited = await sendInit(login, locale, dispatch)
  if (commited) {
    dispatch(deleteSubmitForm(REDUCER))
  } else {
    dispatch(deleteSubmitForm(REDUCER))
  }
}

export const commit = ({ restore_code, password }) => async (dispatch, getState) => {
  dispatch(addSubmitForm(REDUCER))
  const state = getState()
  const email = _.get(state, 'password_recovery.data.login.value', false)
  let commited = await sendCommit(email, restore_code, password, dispatch)
  if (commited) {
    dispatch(deleteSubmitForm(REDUCER))
  } else {
    dispatch(deleteSubmitForm(REDUCER))
  }


  if (email !== false) {
    dispatch(login({ email, password }))
    setTimeout(() => {
      dispatch(reset())
    }, 2500)
  }
}

export default createReducer(
  {
    [initRequest]: (state) => ({ ...state }),
    [initSuccess]: (state) => ({ ...state, codeSent: true }),
    [initFailure]: (state) => ({ ...state }),

    [commitRequest]: (state) => ({ ...state }),
    [commitSuccess]: (state) => ({ ...state }),
    [commitFailure]: (state) => ({ ...state, codeSent: false }),

    [reset]: (state) => ({ ...state, ...initialState }),

    [change]: (state, data) => ({ ...state, data: {...state.data, ...data}}),
  }, 
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/password_recovery.js